import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=2009ff16"
import script from "./ContactContent.vue?vue&type=script&lang=js"
export * from "./ContactContent.vue?vue&type=script&lang=js"
import style0 from "./ContactContent.vue?vue&type=style&index=0&id=2009ff16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports